export const stringFormat = (
  template: string,
  ...args: (string | number)[]
): string => {
  return template.replace(/{(\d+)}/g, (match, index) => {
    const arg = args[parseInt(index)];
    return arg !== undefined ? String(arg) : match;
  });
};

/**
 * Returns the first non-null, non-undefined, non-empty string.
 */
export const firstNonEmpty = (
  ...values: Array<string | null | undefined>
): string | undefined | null => values.find((value) => value?.trim());
